import { useContext } from 'react';

export const useCreateContextHook = <T>({
    context,
    errorMessage,
}: {
    context: React.Context<T>;
    errorMessage: string;
}): T => {
    const store = useContext(context);

    if (!store) {
        throw new Error(errorMessage);
    }

    return store;
};
